export default __webpack_public_path__ + "static/media/ad_S1.16ec5039.png";